import { render } from "./OptionMenuFooter.vue?vue&type=template&id=5c4b7e22&scoped=true"
import script from "./OptionMenuFooter.vue?vue&type=script&lang=js"
export * from "./OptionMenuFooter.vue?vue&type=script&lang=js"

import "./OptionMenuFooter.vue?vue&type=style&index=0&id=5c4b7e22&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c4b7e22"]])

export default __exports__